import styled, { css } from 'styled-components'

export const ListWrapper = styled.ul`
	padding: 0;
	margin: 0;
	list-style: none;
	width: 100%;
	font-size: 15px;
	line-height: 1.2;
	letter-spacing: -0.3px;
`

export const ListItem = styled.li`
	padding: 12px;
	color: #333333;
	border-bottom: 1px solid #e5e5e5;
	cursor: pointer;

	font-size: 16px;
	line-height: 1.125;
	letter-spacing: -0.26px;

	min-height: 48px;
	display: flex;
	justify-content: space-between;
	flex-direction: row-reverse;

	&:last-child {
		border-bottom: none;
	}

	${props =>
		props.isIxigoPartnersSite
			? `
	&:hover {
		background-color: #FFAF95;
		color: #FFFFFF;
	}`
			: `&:hover {
		background-color: rgba(24, 149, 179, 0.08);
		color: #000;
	}`}
	${props =>
		props.showFlexLayout
			? css`
					display: flex;
					width: 100%;
					align-items: center;
					justify-content: space-between;
			  `
			: null};
`

export const RightSideText = styled.span`
	${props =>
		props.showFlexLayout
			? css`
					float: right;
					min-width: 50px;
					text-align: right;
					color: #888888;
					font-weight: 600;

					font-size: 15px;
					line-height: 1.2;
					letter-spacing: -0.3px;
			  `
			: props.isIxigoPartnersSite
			? css`
					color: #fff;
			  `
			: null};
`

export const AirportCityList = ({
	listData = [],
	callBackAction,
	isIxigoPartnersSite,
}) => {
	const clickAction = (e, index) => {
		e && e.preventDefault()
		callBackAction(listData[index].value, listData[index].label)
	}

	return (
		<ListWrapper>
			{(listData || []).map((listObj, index) => {
				return (
					<ListItem
						key={index}
						onClick={e => clickAction(e, index)}
						isIxigoPartnersSite={isIxigoPartnersSite}
					>
						<RightSideText>{listObj.value}</RightSideText>
						{listObj.label}
					</ListItem>
				)
			})}
		</ListWrapper>
	)
}
